import { createSaga } from './saga-helpers';

import * as Api from '../api/roles-api';

const watchGetRoles = createSaga({
    type: 'ROLES_FETCH',
    fn: Api.fetchRoles,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        roles: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateRole = createSaga({
    type: 'ROLE_CREATE',
    fn: Api.createRole,
    args: action => [action.payload.role],
    successPayload: ({ id: roleId }, action) => ({
        roleId,
        fragment: action.payload.role
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.role
    })
});

const watchGetRole = createSaga({
    type: 'ROLE_FETCH',
    fn: Api.fetchRole,
    args: action => [action.payload.roleId],
    successPayload: role => ({ role })
});

const watchUpdateRole = createSaga({
    type: 'ROLE_UPDATE',
    fn: Api.updateRole,
    args: action => [action.payload.roleId, action.payload.roleProps],
    successPayload: role => ({ role })
});

const watchAddRolePermission = createSaga({
    type: 'ROLE_ADD_PERMISSION',
    fn: Api.addRolePermission,
    args: action => [action.payload.roleId, action.payload.permission],
    successPayload: role => ({ role })
});

const watchRemoveRolePermission = createSaga({
    type: 'ROLE_REMOVE_PERMISSION',
    fn: Api.removeRolePermission,
    args: action => [action.payload.roleId, action.payload.permission],
    successPayload: role => ({ role })
});

const watchRemoveRole = createSaga({
    type: 'ROLE_REMOVE',
    fn: Api.removeRole,
    args: action => [action.payload.roleId]
});

const sagas = [watchGetRoles, watchCreateRole, watchGetRole, watchUpdateRole, watchAddRolePermission, watchRemoveRolePermission, watchRemoveRole];

export default sagas;
